import React from 'react';

import { MultiSelect } from '@metarouter-private/mr-mui';

import useEventDebuggerIntegrationsSelect from './useEventDebuggerIntegrationsSelect';

export default function EventDebuggerIntegrationsSelect() {
  const props = useEventDebuggerIntegrationsSelect();

  return <MultiSelect {...props} />;
}
